var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconMenuClose = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", { transform: "translate(2.5 -1.5)" },
                React.createElement("path", { d: "M1.9,16.5h4.7" })),
            React.createElement("g", { transform: "translate(2.5 -1.5)" },
                React.createElement("path", { d: "M1.9,25.5h21.2" })),
            React.createElement("g", { transform: "translate(2.5 -1.5)" },
                React.createElement("path", { d: "M1.9,7.5h21.2" })),
            React.createElement("g", null,
                React.createElement("path", { d: "M20.9,9.1L9.1,20.9" }),
                React.createElement("path", { d: "M9.1,9.1l11.9,11.9" })),
            React.createElement("path", { d: "M21.8,15h3.8" }))));
});
export default IconMenuClose;
//# sourceMappingURL=IconMenuClose.js.map